import styled from 'styled-components';
import { token, Spacer } from '@zillow/constellation';

export const StyledTourCardContentContainer = styled(Spacer)`
    border-top: 1px solid ${token('colors.gray300')};
    display: flex;
    flex-direction: column;
`;
